import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d2d21808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { class: "subtitle" }

import {computed, Reactive, reactive, Ref, ref} from "vue";
import {useRoute} from "vue-router";
import {GuildSettings} from "@/types/GuildSettings";
import config from "@/config.json";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildGeneralView',
  props: {
    settings: {}
  },
  emits: ['submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute();
let settings: Reactive<GuildSettings> = reactive(JSON.parse(JSON.stringify(props.settings)));
let valid = ref(true);
let submitting = ref(false);
const languageItems = computed(() => [
  {title: i18n.global.t('GuildGeneral.ru'), value: 'ru'},
  {title: i18n.global.t('GuildGeneral.en'), value: 'en'}
]);

const prefixRules = [
  (prefix: string) => !!prefix || i18n.global.t('GuildGeneral.errors.noPrefix'),
  (prefix: string) => prefix.length < 20 || i18n.global.t('GuildGeneral.errors.prefixLength'),
  (prefix: string) => !prefix.match(/[`| ]/gmi) || i18n.global.t('GuildGeneral.errors.invalidChars'),
]

async function submit() {
  submitting.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/general`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify({
          prefix: settings.prefix,
          language: settings.language
        })
      })
  if(response.ok) emit('submitted', 'success', settings)
  else emit('submitted', 'error')
  submitting.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _unref(valid),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('GuildGeneral.subtitles.prefix')), 1),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(settings).prefix,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).prefix) = $event)),
          class: "prefix",
          color: "primary",
          counter: "20",
          rules: prefixRules,
          label: _ctx.$t('GuildGeneral.subtitles.prefix')
        }, null, 8, ["modelValue", "label"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('GuildGeneral.subtitles.language')), 1),
        _createVNode(_component_v_select, {
          modelValue: _unref(settings).language.commands,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings).language.commands) = $event)),
          class: "language",
          color: "primary",
          items: languageItems.value,
          label: _ctx.$t('GuildGeneral.subtitles.commands')
        }, null, 8, ["modelValue", "items", "label"]),
        _createVNode(_component_v_select, {
          modelValue: _unref(settings).language.interface,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings).language.interface) = $event)),
          class: "language",
          color: "primary",
          items: languageItems.value,
          label: _ctx.$t('GuildGeneral.subtitles.interface')
        }, null, 8, ["modelValue", "items", "label"]),
        _createVNode(_component_v_btn, {
          class: "submit",
          disabled: _unref(valid) === false,
          loading: _unref(submitting),
          size: "large",
          color: "secondary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "save-icon" }, {
              default: _withCtx(() => [
                _createTextVNode("save")
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildGeneral.submit')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})